import { useState as e } from "react";
var n = function n() {
    return "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
  },
  t = function t(n) {
    var t = e(!1),
      o = t[0],
      r = t[1],
      c = function c() {
        r(!0), n && n();
      };
    return {
      onLoad: function onLoad(e) {
        if (!o) {
          var n = e.currentTarget,
            t = new Image();
          t.src = n.currentSrc, t.decode ? t.decode().catch(function () {}).then(function () {
            c();
          }) : c();
        }
      },
      isLoaded: o,
      setLoaded: c
    };
  };
export { n as hasNativeLazyLoadSupport, t as useImageLoader };